import { Text } from '~/components/typography'
import ToggleSwitch from './Switch'
import { type ToggleSwitchProps } from './Switch'

type ToggleProps = ToggleSwitchProps & {
  label?: string
  left: string
  right: string
}

export default function Toggle({
  label,
  left,
  right,
  onChange,
  disabled = false,
  checked = false,
  level = 3,
  containerClassName,
  labelClassName,
  switchClassName,
  buttonClassName,
  fill,
}: ToggleProps) {
  return (
    <div className="flex flex-col gap-2 text-left">
      {label && (
        <Text level={4} className="text-[10px] font-medium text-neutral-midfi-grey sm:text-xs">
          {label}
        </Text>
      )}
      <div className="flex items-center">
        <ToggleSwitch
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          fill={fill}
          left={left}
          right={right}
          level={level}
          containerClassName={containerClassName}
          labelClassName={labelClassName}
          switchClassName={switchClassName}
          buttonClassName={buttonClassName}
        />
      </div>
    </div>
  )
}
